import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom'
import { Input, Row, Table, UncontrolledTooltip } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import {
    isUserAllowedToAccessRestaurantBrand,
    localizeStatuses,
    localizeCountryNames
} from '../../utils/CommonUtils';
import RestaurantUtils from '../../utils/RestaurantUtils';
import { NOT_CONFIGURED } from '../../utils/Constants';
import i18n from '../../i18next';

import PopoverItem from './PopoverItem';

class CustomTable extends Component {
    renderRestaurantsTable() {
        if (!this.props.tableData) {
            return <div />;
        }

        return (
            <Row>
                <Table responsive>
                    <thead>
                        <tr className="d-flex">
                            <th className="col-1">{i18n.t('screens:restaurantsScreen.country')}</th>
                            <th className="col-2">{i18n.t('screens:restaurantsScreen.brand')}</th>
                            <th className="col-3">{i18n.t('screens:restaurantsScreen.location')}</th>
                            <th className="col-2">{i18n.t('common:form.phone')}</th>
                            <th className="col-1">{i18n.t('screens:restaurantsScreen.posType')}</th>
                            <th className="col-1">{i18n.t('screens:orderHistoryScreen.status')}</th>
                            <th className="col-1">{i18n.t('screens:restaurantsScreen.posStatus')}</th>
                            <th className="col-1">{i18n.t('screens:restaurantsScreen.pause')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRestaurantsTableRows()}
                    </tbody>
                </Table>
            </Row>
        );
    }

    renderBrandsTable() {
        const { emailOverflow, rowMarginTop } = this.props.styles;

        return (
            <Row style={rowMarginTop}>
                <Table responsive hover>
                    <thead>
                        <tr className="d-flex">
                            <th className="col-2">{i18n.t('common:form.name')}</th>
                            <th className="col-3">{i18n.t('screens:menuConfigScreen.category')}</th>
                            <th className="col-2">{i18n.t('screens:brandScreen.manager')}</th>
                            <th className="col-2">{i18n.t('common:form.phone')}</th>
                            <th className="col-2" style={emailOverflow} >{i18n.t('common:form.email')}</th>
                            <th className="col-1">{i18n.t('screens:adminsScreen.lastActiveTime')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderBrandsTableRows()}
                    </tbody>
                </Table>
            </Row>
        );
    }

    renderBrandTable() {
        if (!this.props.tableData) {
            return <div></div>;
        }

        return (
            <Table hover responsive style={{ textAlign: 'center' }}>
                <thead>
                    <tr className="d-flex">
                        <th className="col-2" style={this.props.styles.tableThStyle}>{i18n.t('screens:generalScreen.restaurantName')}</th>
                        <th className="col-1" style={this.props.styles.tableThStyle}>{i18n.t('screens:restaurantsScreen.country')}</th>
                        <th className="col-2" style={this.props.styles.tableThStyle}>{i18n.t('screens:restaurantsScreen.location')}</th>
                        <th className="col-1" style={this.props.styles.tableThStyle}>{i18n.t('common:form.phone')}</th>
                        <th className="col-2" style={this.props.styles.tableThStyle}>{i18n.t('common:form.email')}</th>
                        <th className="col-2" style={this.props.styles.tableThStyle}>{i18n.t('screens:generalScreen.restaurantManager')}</th>
                        <th className="col-1" style={this.props.styles.tableThStyle}>{i18n.t('screens:adminsScreen.lastActiveTime')}</th>
                        <th className="col-1" style={this.props.styles.tableThStyle}>{i18n.t('screens:restaurantsScreen.pause')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderBrandRestaurants()}
                </tbody>
            </Table>
        );
    }

    renderLoyaltyUsersTable() {

        if (!this.props.tableData) {
            return <div></div>;
        }

        return (
            <Table hover responsive>
                <thead>
                    <tr className="d-flex">
                        <th className="col-1" style={this.props.styles.tableThStyle}>{i18n.t('screens:loyaltyScreen.userId')}</th>
                        <th className="col-3" style={this.props.styles.tableThStyle}>{i18n.t('screens:loyaltyScreen.name')}</th>
                        <th className="col-3" style={this.props.styles.tableThStyle}>{i18n.t('common:form.phone')}</th>
                        <th className="col-3" style={this.props.styles.tableThStyle}>{i18n.t('common:form.email')}</th>
                        <th className="col-2" style={this.props.styles.tableThStyle}>{i18n.t('screens:loyaltyScreen.orderCount')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderLoyaltyUsers()}
                </tbody>
            </Table>
        );
    }

    renderLoyaltyUsers() {
        if (this.props.tableData) {
            let content = this.props.tableData;

            return content.map((user, i) => {

                let key = { 'key': user.id };

                return (
                    <tr style={{ cursor: 'pointer' }} {...key} className="d-flex" onClick={() => {
                        this.props.renderUserCodes(user.id, user.name)
                    }}>
                        <td className="col-1" style={this.props.styles.textOverflowHidden}>
                            {user.id}
                        </td>
                        <td className="col-3" style={this.props.styles.textOverflowHidden}>
                            <NavLink to="#">
                                {user.name}
                            </NavLink>
                        </td>
                        <td className="col-3" style={this.props.styles.textOverflowHidden}>
                            {user.phone}
                        </td>
                        <td className="col-3" style={this.props.styles.textOverflowHidden}>
                            {user.email}
                        </td>
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            {user.orderCount}
                        </td>
                    </tr>
                );
            });
        } else {
            return <div />;
        }
    }

    renderRestaurantsTableRows() {
        if (this.props.tableData) {
            let content = this.props.tableData;

            return content.map((restaurant, i) => {
                const posStatusColor = RestaurantUtils.getPosStatusColor(restaurant.posStatus);
                const statusColor = RestaurantUtils.getStatusColor(restaurant.status);
                const posColor = { color: posStatusColor };
                const openClosedColor = { color: statusColor };

                const posStatusPaused = restaurant.posPaused;
                const disablePosStatusPaused = (restaurant.posStatus === NOT_CONFIGURED) ? true : false;

                let key = { 'key': restaurant.restaurantId };
                let element;
                const { inputCheckbox, cursorPointer } = this.props.styles;

                const userAllowedToAccessBrand = isUserAllowedToAccessRestaurantBrand(restaurant, this.props.currentUser);

                if (userAllowedToAccessBrand) {
                    element = (
                        restaurant.webSite !== null && restaurant.webSite !== undefined & restaurant.webSite !== '' ?
                        <td className="col-2">
                            <span id={"restaurantName" + i} style={cursorPointer}>  
                                <a style={{ marginRight: 5 }} href={restaurant.webSite} target="_blank" id={"globalIcon" + i}>
                                	<MaterialIcon icon="public" color="#0288D1" size={18} /> 
                                </a>
                                <NavLink id={restaurant.restaurantChainId}
                                    tag={Link}
                                    to={`/brand/${restaurant.restaurantChainId}`}
                                >
                                    {restaurant.restaurantChainName}
                                </NavLink>
                            </span>
                            <UncontrolledTooltip placement="top" target={"globalIcon" + i} >
                                {i18n.t('screens:restaurantsScreen.linkTo')}{restaurant.restaurantChainName}{i18n.t('screens:restaurantsScreen.website')}
                            </UncontrolledTooltip>
                        </td>
                        : 
                        <td className="col-2">
                            <span id={"restaurantName" + i} style={cursorPointer}>
                                <NavLink id={restaurant.restaurantChainId}
                                    tag={Link}
                                    to={`/brand/${restaurant.restaurantChainId}`}
                                >
                                    {restaurant.restaurantChainName}
                                </NavLink>
                            </span>
                        </td>
                    );
                } else {
                    element = (
                        restaurant.webSite !== null && restaurant.webSite !== undefined & restaurant.webSite !== '' ?
                        <td className="col-2">
                            {restaurant.restaurantChainName}
                            <span id={"restaurantName" + i} style={cursorPointer}>
                                <a href={restaurant.webSite} style={{ marginRight: 5 }} target="_blank" id={"globalIcon" + i}>
                                	<MaterialIcon icon="public" color="#0288D1" size={18} /> 
                                </a>
                            </span>
                            <UncontrolledTooltip placement="top" target={"globalIcon" + i} >
                                {i18n.t('screens:restaurantsScreen.linkTo')}{restaurant.restaurantChainName}{i18n.t('screens:restaurantsScreen.website')}
                            </UncontrolledTooltip>
                        </td>
                        :
                        <td className="col-2">
                            <span id={"restaurantName" + i} style={cursorPointer}>
                                <NavLink id={restaurant.restaurantChainId}
                                    tag={Link}
                                    to={`/brand/${restaurant.restaurantChainId}`}
                                >
                                    {restaurant.restaurantChainName}
                                </NavLink>
                            </span>
                        </td>
                    );
                }

                return (
                    <tr {...key} className="d-flex">
                        <td className="col-1">{localizeCountryNames(restaurant.country)}</td>
                        {element}
                        <td className="col-3">
                            <NavLink id={restaurant.restaurantId}
                                tag={Link}
                                to={`/restaurant/${restaurant.restaurantId}/settings/general`}
                            >{restaurant.location}</NavLink>
                        </td>
                        <td className="col-2">
                            <PopoverItem id={'restaurantPhone' + i} item={restaurant.phone} styles={this.props.styles} />
                        </td>
                        <td className="col-1">{restaurant.posType}</td>
                        <td className="col-1" style={openClosedColor}>{localizeStatuses(restaurant.status)}</td>
                        <td className="col-1" style={posColor}>{localizeStatuses(restaurant.posStatus)}</td>
                        <td className="col-1">
                            <Input type="checkbox" style={inputCheckbox} id={restaurant.restaurantId}
                                name={restaurant.restaurantId} checked={posStatusPaused}
                                disabled={disablePosStatusPaused}
                                onChange={this.props.handlePause} />
                        </td>
                    </tr>
                );
            });
        }
    }

    renderBrandsTableRows() {
        const { emailOverflow } = this.props.styles;
        let content = this.props.tableData;
        return content.map((brand, i) => {

            let key = { key: brand.chainId };

            const passPropsToBrandScreen = {
                pathname: `/brand/${brand.chainId}`,
                state: {
                    pathname: this.props.location.pathname,
                    title: 'Brands'
                }
            };

            return (
                <tr {...key} className="d-flex">
                    <td className="col-2" style={emailOverflow}>
                        <NavLink
                            id={brand.chainId}
                            tag={Link}
                            to={passPropsToBrandScreen}
                        >{brand.chainName}
                        </NavLink>
                    </td>
                    <td className="col-3" style={emailOverflow}>{brand.categories}</td>
                    <td className="col-2" style={emailOverflow}>{brand.managerName}</td>
                    <td className="col-2" style={emailOverflow}>
                        <PopoverItem id={'brandManagerPhone' + i} item={brand.managerPhone} styles={this.props.styles} />
                    </td>
                    <td className="col-2" style={emailOverflow}>
                        <PopoverItem id={'brandManagerEmail' + i} item={brand.managerEmail} styles={this.props.styles} />
                    </td>
                    <td className="col-1" style={emailOverflow}>
                        <PopoverItem id={'lastActiveTime' + i} item={brand.lastActiveTime} styles={this.props.styles} />
                    </td>
                </tr>
            );
        });
    }

    renderBrandRestaurants() {
        if (this.props.tableData) {
            let content = this.props.tableData;

            return content.map((restaurant, i) => {
                const posStatusPaused = restaurant.posPaused;
                const disablePosStatusPaused = (restaurant.posStatus === NOT_CONFIGURED) ? true : false;
                let key = { 'key': restaurant.restaurantId };

                return (
                    <tr {...key} className="d-flex">
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'restaurantName' + i} item={restaurant.restaurantName} styles={this.props.styles} />
                        </td>
                        <td className="col-1" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'restaurantCountry' + i} item={localizeCountryNames(restaurant.country)} styles={this.props.styles} />
                        </td>
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            <NavLink id={restaurant.restaurantId}
                                tag={Link}
                                to={`/restaurant/${restaurant.restaurantId}/settings/general`}
                                style={this.props.styles.locationColor}>
                                {restaurant.location}
                            </NavLink>
                        </td>
                        <td className="col-1" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'restaurantPhone' + i} item={restaurant.phone} styles={this.props.styles} />
                        </td>
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'restaurantEmail' + i} item={restaurant.email} styles={this.props.styles} />
                        </td>
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'restaurantManagerName' + i} item={restaurant.managerName} styles={this.props.styles} />
                        </td>
                        <td className="col-1" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'userLastActiveTime' + i} item={restaurant.userLastActiveTime} styles={this.props.styles} />
                        </td>
                        <td className="col-1" style={this.props.styles.textOverflowHidden}>
                            <Input type="checkbox" style={{ marginLeft: '0px' }} id={restaurant.restaurantId}
                                name={restaurant.restaurantId} checked={posStatusPaused} disabled={disablePosStatusPaused}
                                onChange={this.props.handlePause} />
                        </td>
                    </tr>
                );
            });
        } else {
            return <div />;
        }
    }

    render() {
        let table = null;

        if (!this.props.tableData) {
            return (
                <div></div>
            );
        }

        if (this.props.tableName === 'restaurantsTable') {
            table = this.renderRestaurantsTable();
        }

        if (this.props.tableName === 'brandsTable') {
            table = this.renderBrandsTable();
        }

        if (this.props.tableName === 'brandRestaurantsTable') {
            table = this.renderBrandTable();
        }

        if (this.props.tableName === 'loyaltyUsersTable') {
            table = this.renderLoyaltyUsersTable();
        }

        return <div>{table}</div>;
    }
}

export default CustomTable;


// WEBPACK FOOTER //
// ./src/components/common/CustomTable.js